import { deriveTaxonomyLevelsFromFacets } from 'src/adapters/storeToPageURL/deriveTaxonomyLevelsFromFacets';
import { TAXONOMY_MULTISELECT_DELIMITER, TAXONOMY_SKIP_SEGMENT } from 'src/adapters/urlDelimiters';
import type {
  ProductsQueryState,
  SyncProductsQueryFromURLPayload,
} from '../types/ProductsQueryState';
import { markActiveFacetOptions } from './markActiveFacetOptions';
import { markActiveSortOption } from './markActiveSortOption';

export const levelsToPageCategories = (taxonomyLevelValues: string[]): string[] => [
  taxonomyLevelValues
    .filter((v) => v !== TAXONOMY_SKIP_SEGMENT)
    .map((v) => v.split(TAXONOMY_MULTISELECT_DELIMITER).join('/'))
    .join(' > '),
];

export const getProductsQueryStateFromSyncPayload = (
  productsQuery: ProductsQueryState,
  active: SyncProductsQueryFromURLPayload,
): ProductsQueryState => {
  const facets = markActiveFacetOptions(productsQuery.facets, active.activeFacetValuesByKey);

  // For taxonomy pages pageCategories follows the active facet selection; other pages keep
  // whatever was set at SSR-init time (their pathname doesn't change after navigation).
  const pageCategories =
    productsQuery.taxonomyAttributeAliases.length > 0
      ? levelsToPageCategories(
          deriveTaxonomyLevelsFromFacets(facets, productsQuery.taxonomyAttributeAliases),
        )
      : productsQuery.pageCategories;

  return {
    ...productsQuery,
    facets,
    sortOptions: markActiveSortOption(productsQuery.sortOptions, active.activeSort),
    page: active.page,
    searchTerm: active.searchTerm,
    pageCategories,
  };
};
